export class CommonConstants
 {
    static DelegationTelemetryBaseName = 'FxpPlatform.Delegation';
    static DelegationFeatureName = `FxpPlatform.ManageDelegation`;
}